import { Transform } from 'class-transformer';
import { IsEmail, IsNotEmpty, IsString } from 'class-validator';

export class BugReportForm {
  @IsEmail({}, { message: 'Enter a valid email address.' })
  @IsNotEmpty()
  email: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  overview: string;

  @IsString()
  @IsNotEmpty()
  stepsToReproduce: string;

  @Transform(({ value }) => value)
  attachments: File[] = [];
}
